import React from 'react';
import PageShell from './PageShell';
import ProductsSection from '../components/ProductsSection';
import { products } from '../mock';
import { useLang } from '../i18n/LanguageContext';

const ProdottiPage = () => {
  const { t } = useLang();
  return (
    <PageShell eyebrow={t('products.eyebrow')} title={t('products.title')} image={products[0].image}>
      <ProductsSection />
    </PageShell>
  );
};

export default ProdottiPage;
